import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hidden md:block bg-primary py-2">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center gap-4 text-sm text-white">
          <span>© {currentYear} Rivka Traiteur</span>
          <Link to="/mentions-legales" className="hover:underline">
            Mentions Légales
          </Link>
          <Link to="/cgv" className="hover:underline">
            CGV
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 